import React from "react";
import { Card } from "@mui/material";

interface PanelProps {
  children: React.ReactNode;
}

/**
 * The bordered panel the detail drawers group their sections in.
 *
 * `Card variant="outlined"` rather than `Paper`, per OUT-1105: the theme gives
 * Paper a background and nothing else, so the surface and hairline come from
 * the Card. It used to hardcode `bg-mainWhite`, which is why these panels
 * stayed white in dark mode.
 */
const CustomPanel: React.FC<PanelProps> = ({ children }) => (
  <Card
    variant="outlined"
    sx={{
      position: "relative",
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      // A drawer body is a scrolling flex column, so a panel that does not say
      // this is squeezed to nothing and clips its own content (OUT-1407).
      flexShrink: 0,
    }}
  >
    {children}
  </Card>
);

export default CustomPanel;
